export const blockIconsPhotoandimageAdjustNew = (
	<span className='material-symbols-outlined'>adjust</span>
);
